"use strict";
/* Auto Generated */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionType = void 0;
var PermissionType;
(function (PermissionType) {
    PermissionType[PermissionType["none"] = 0] = "none";
    PermissionType[PermissionType["usersView"] = 1] = "usersView";
    PermissionType[PermissionType["usersManage"] = 2] = "usersManage";
    PermissionType[PermissionType["userPermissionsView"] = 3] = "userPermissionsView";
    PermissionType[PermissionType["userPermissionsManage"] = 4] = "userPermissionsManage";
    PermissionType[PermissionType["appView"] = 5] = "appView";
    PermissionType[PermissionType["appManage"] = 6] = "appManage";
    PermissionType[PermissionType["translationView"] = 7] = "translationView";
    PermissionType[PermissionType["translationManage"] = 8] = "translationManage";
    PermissionType[PermissionType["translationKeyView"] = 9] = "translationKeyView";
    PermissionType[PermissionType["translationKeyManage"] = 10] = "translationKeyManage";
    PermissionType[PermissionType["hangfireDashboardView"] = 11] = "hangfireDashboardView";
    PermissionType[PermissionType["hangfireDashboardManage"] = 12] = "hangfireDashboardManage";
    PermissionType[PermissionType["languageView"] = 13] = "languageView";
    PermissionType[PermissionType["languageManage"] = 14] = "languageManage";
    PermissionType[PermissionType["cacheView"] = 15] = "cacheView";
    PermissionType[PermissionType["cacheManage"] = 16] = "cacheManage";
    PermissionType[PermissionType["guideSubmissionView"] = 17] = "guideSubmissionView";
    PermissionType[PermissionType["guideSubmissionManage"] = 18] = "guideSubmissionManage";
    PermissionType[PermissionType["versionView"] = 19] = "versionView";
    PermissionType[PermissionType["versionManage"] = 20] = "versionManage";
    PermissionType[PermissionType["donationView"] = 21] = "donationView";
    PermissionType[PermissionType["donationManage"] = 22] = "donationManage";
    PermissionType[PermissionType["steamBranchManage"] = 23] = "steamBranchManage";
    PermissionType[PermissionType["teamMemberView"] = 24] = "teamMemberView";
    PermissionType[PermissionType["teamMemberManage"] = 25] = "teamMemberManage";
    PermissionType[PermissionType["translationReportView"] = 26] = "translationReportView";
    PermissionType[PermissionType["translationReportManage"] = 27] = "translationReportManage";
    PermissionType[PermissionType["licenceView"] = 28] = "licenceView";
    PermissionType[PermissionType["licenceManage"] = 29] = "licenceManage";
    PermissionType[PermissionType["appNoticeView"] = 30] = "appNoticeView";
    PermissionType[PermissionType["appNoticeManage"] = 31] = "appNoticeManage";
    PermissionType[PermissionType["feedbackFormView"] = 32] = "feedbackFormView";
    PermissionType[PermissionType["feedbackFormManage"] = 33] = "feedbackFormManage";
    PermissionType[PermissionType["translationSubmissionView"] = 34] = "translationSubmissionView";
    PermissionType[PermissionType["databaseMaintenance"] = 35] = "databaseMaintenance";
})(PermissionType = exports.PermissionType || (exports.PermissionType = {}));
